export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.wixstatic.com/media/0184a2_a8bf1f9416934718b0472844df026b88~mv2.gif"
              alt="R&R General Contracting"
              className="h-16 w-auto mb-4"
            />
            <p className="text-sm text-slate-300 leading-relaxed mb-4">
              Professional waterproofing and moisture control solutions for residential and commercial properties in Grass Valley.
            </p>
            <div className="text-sm text-slate-400">
              <strong>License No. 534840</strong>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#process" className="text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Our Process
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Project Gallery
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-sm text-slate-300">Basement Waterproofing</li>
              <li className="text-sm text-slate-300">Crawl Space Encapsulation</li>
              <li className="text-sm text-slate-300">Foundation Repair</li>
              <li className="text-sm text-slate-300">Sump Pump Installation</li>
              <li className="text-sm text-slate-300">French Drains</li>
              <li className="text-sm text-slate-300">Dry-Rot Repair</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:530-277-9803" className="flex items-center text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer">
                  <i className="ri-phone-line mr-2"></i>
                  (530) 277-9803
                </a>
              </li>
              <li>
                <a href="mailto:RRGC03@gmail.com" className="flex items-center text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer break-all">
                  <i className="ri-mail-line mr-2"></i>
                  RRGC03@gmail.com
                </a>
              </li>
              <li>
                <a href="mailto:RRGC@NCCN.net" className="flex items-center text-sm text-slate-300 hover:text-teal-400 transition-colors cursor-pointer break-all">
                  <i className="ri-mail-line mr-2"></i>
                  RRGC@NCCN.net
                </a>
              </li>
              <li className="flex items-start text-sm text-slate-300">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>Serving Grass Valley<br />& Surrounding Areas</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-slate-400">
              © {currentYear} R&R General Contracting LLC. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-slate-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
